import { render, staticRenderFns } from "./GlobalNewsList.vue?vue&type=template&id=476e0bc1&"
import script from "./GlobalNewsList.vue?vue&type=script&lang=js&"
export * from "./GlobalNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports